import { getColumnWidth } from "../helpers";

const COL_WIDTH = 135;

export default function getInventoryValuationColumns(windowWidth) {
  return [
    {
      columnId: "titlesColumn",
      width: 300
    },
    { columnId: 1, width: 300 },
    { columnId: 2, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 3, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 4, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 5, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 6, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 7, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 8, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) },
    { columnId: 9, width: windowWidth < 1363 ? COL_WIDTH : getColumnWidth(0.75 / 4, windowWidth) }
  ];
}
